// ── trainingData.js ───────────────────────────────────────────────────────────
// All static data arrays used across TrainingPage sub-components.

export const TRACKS = [
  { icon: "⚛️",  name: "Frontend Development", desc: "React, TypeScript, UI/UX" },
  { icon: "🖥️",  name: "Backend Development",  desc: "Node.js, Express, APIs" },
  { icon: "🗄️",  name: "Database & APIs",       desc: "MongoDB, PostgreSQL, REST" },
  { icon: "☁️",  name: "Cloud & DevOps",         desc: "AWS, Docker, Kubernetes" },
  { icon: "🤖",  name: "AI / ML Engineering",    desc: "Python, TensorFlow, LLMs" },
  { icon: "🎨",  name: "UI/UX Design",           desc: "Figma, Design Systems" },
  { icon: "🔒",  name: "Cybersecurity",          desc: "Pen-testing, Auth, Audits" },
  { icon: "📱",  name: "Mobile Development",     desc: "React Native, Android, iOS" },
];

export const PERKS = [
  { icon: "🏗️", title: "Real Project Experience",  desc: "Work on QuantumLogics live products — not toy apps. Your code ships to actual users." },
  { icon: "👨‍💻", title: "Senior Mentorship",         desc: "Direct guidance from experienced engineers who built the stack you'll be working on." },
  { icon: "📜", title: "Official Certificate",       desc: "Verified training certificate + internship completion letter upon finishing." },
  { icon: "💼", title: "Portfolio Projects",         desc: "Leave with GitHub contributions and real project URLs to show future employers." },
  { icon: "🌐", title: "Industry Network",           desc: "Join Pakistan's largest open-source community and connect with 10,000+ devs." },
  { icon: "🎯", title: "Choose Your Track",          desc: "Pick any field that fits your goals. One program, your direction." },
];

export const STEPS = [
  { num: "01", icon: "💳", title: "Pay & Apply",        desc: "Send ₨2,000 via JazzCash, EasyPaisa, or bank card and submit your confirmation." },
  { num: "02", icon: "📞", title: "Onboarding Call",    desc: "A quick 15-min intro call to match you with the right mentor and Discord role." },
  { num: "03", icon: "⚡", title: "Month of Training",  desc: "Hands-on training on real QuantumLogics projects, guided daily by senior devs." },
  { num: "04", icon: "🚀", title: "Free Internship",    desc: "3 months as a full team member — ship features, earn your letter, grow your career." },
];

export const PAYMENT_METHODS = [
  {
    id: "jazzcash", cls: "jazz", logo: "🟥",
    name: "JazzCash", sub: "Mobile wallet", color: "#e52020",
    details: { number: "03714467235", accountName: "Muhammad Saad Amin", label: "JazzCash Number" },
  },
  {
    id: "easypaisa", cls: "easy", logo: "🟩",
    name: "EasyPaisa", sub: "Mobile wallet", color: "#00a651",
    details: { number: "03714467235", accountName: "Muhammad Saad Amin", label: "EasyPaisa Number" },
  },
  {
    id: "bankcard", cls: "bank", logo: "🏦",
    name: "Bank Card", sub: "Askari Bank", color: "#1a56db",
    details: { number: "04340200000408", accountName: "Muhammad Saad Amin", label: "Card / Account Number", bank: "Askari Bank" },
  },
];

export const DISCORD_CHANNELS = [
  { name: "announcements",      badge: null },
  { name: "open-source-projects", badge: "42" },
  { name: "job-board",          badge: "18" },
  { name: "code-reviews",       badge: "7" },
  { name: "mentorship",         badge: null },
];

export const STATS = [
  ["1",    "Month Training"],
  ["3",    "Months Internship"],
  ["100%", "Real Projects"],
  ["₨2K",  "Total Cost"],
  ["10K+", "Community Members"],
  ["FREE", "Internship"],
];

export const PRICING_FEATURES = [
  "1 month intensive, project-based training",
  "3 months FREE internship",
  "Mentorship from senior engineers",
  "Official training & internship certificate",
  "Real-world portfolio contributions",
  "Work on live products, not simulations",
  "Access to Pakistan's largest Discord community",
  "Exclusive trainee Discord role & channels",
];
